/* No source is attached until the film is visible or explicitly started. */
(() => {
  const initialize = (scope = document) => {
    scope.querySelectorAll('[data-tv-film]').forEach((film) => {
      if (film.dataset.ready) return;
      film.dataset.ready = 'true';
      const video = film.querySelector('video');
      const toggle = film.querySelector('[data-tv-film-toggle]');
      const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const connection = navigator.connection;
      let visible = false;
      let userPaused = false;
      let ended = false;
      // A pause is automatic only while the video is outside the usable viewport.
      const canAutoPlay = () => !motion.matches && !connection?.saveData && !userPaused && !ended;
      const load = () => {
        if (!video.getAttribute('src') && video.dataset.src) {
          video.src = video.dataset.src;
          video.muted = true;
          video.load();
        }
      };
      const play = () => {
        load();
        video.play().catch(() => { toggle.textContent = 'Video abspielen'; });
      };
      toggle.hidden = false;
      toggle.addEventListener('click', () => {
        if (video.paused) { userPaused = false; ended = false; play(); }
        else { userPaused = true; video.pause(); }
      });
      video.addEventListener('loadeddata', () => film.classList.add('is-loaded'));
      video.addEventListener('play', () => { toggle.textContent = 'Video pausieren'; });
      video.addEventListener('pause', () => {
        if (visible && !document.hidden && !motion.matches && !connection?.saveData) userPaused = true;
        toggle.textContent = video.ended ? 'Video erneut abspielen' : 'Video abspielen';
      });
      video.addEventListener('ended', () => { ended = true; toggle.textContent = 'Video erneut abspielen'; });
      video.addEventListener('error', () => {
        film.classList.remove('is-loaded');
        toggle.textContent = 'Video erneut laden';
        video.removeAttribute('src');
      });
      const update = () => {
        if (!visible || document.hidden || motion.matches || connection?.saveData) video.pause();
        else if (canAutoPlay()) play();
      };
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(([entry]) => {
          visible = entry.isIntersecting && entry.intersectionRatio >= 0.5;
          update();
        }, { threshold: [0, 0.5] });
        observer.observe(film.querySelector('.tv-film__stage'));
        document.addEventListener('shopify:section:unload', (event) => {
          if (event.target.contains(film)) observer.disconnect();
        }, { once: true });
      }
      document.addEventListener('visibilitychange', update);
      motion.addEventListener('change', update);
      connection?.addEventListener('change', update);
    });
  };
  initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
